/* landing-page.js — shared behavior for all landing-* sections.
   Connector image URLs come from window.WS_LANDING_CONN (set inline by landing-hero). */

/* === WSAddToCart — shared AJAX add-to-cart, mirrors landing-hero.liquid's own
   addVariants() (same cart-drawer section-id discovery, same POST /cart/add.js,
   same cart:update dispatch so the .ws-nav cart-drawer-component auto-opens).
   landing-hero keeps its own local copy (self-contained, already battle-tested,
   left untouched to avoid regressing it) — this shared version is for any other
   landing-* section button that should add-to-cart instead of navigating, given
   it already knows the exact variant id up front (no need to resolve one by
   matching a connector-specific variant title, unlike the hero's toggle). */
window.WSAddToCart = function(variantIds) {
  var ids = (variantIds || []).filter(Boolean);
  if (!ids.length) return Promise.resolve();
  var cartSectionIds = Array.from(new Set(
    Array.from(document.querySelectorAll('cart-items-component'))
      .map(function(c) { return c.dataset.sectionId; })
      .filter(Boolean)
  ));
  var payload = {
    items: ids.map(function(id) { return { id: Number(id), quantity: 1 }; }),
    sections: cartSectionIds.join(','),
    sections_url: window.location.pathname
  };
  return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(payload) })
    .then(function(r) { return r.json(); })
    .then(function(resp) {
      if (resp && resp.status) { console.warn('[WSAddToCart] add failed:', resp.message); return; }
      return fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
        try {
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: 'landing-page',
              data: { source: 'landing-page', itemCount: ids.length, sections: (resp && resp.sections) || {} }
            }
          }));
        } catch (e) {}
      });
    });
};

/* === compatibility carousel === */
(function() {
  var track = document.getElementById('ab-compat-track');
  var prev  = document.getElementById('ab-compat-prev');
  var next  = document.getElementById('ab-compat-next');
  if (!track || !prev || !next) return;
  function getScrollUnit() {
    var card = track.querySelector('.ab-compat-card');
    var div  = track.querySelector('.ab-compat-divider');
    if (!card || !div) return 350;
    var ds = getComputedStyle(div);
    return card.offsetWidth + div.offsetWidth + parseFloat(ds.marginLeft) + parseFloat(ds.marginRight);
  }
  function updateDividers() {
    var unit = getScrollUnit();
    var active = Math.round(track.scrollLeft / unit);
    [].forEach.call(track.querySelectorAll('.ab-compat-divider'), function(d, i) {
      d.classList.toggle('is-active', i === active);
    });
  }
  next.addEventListener('click', function() { track.scrollBy({ left: getScrollUnit(), behavior: 'smooth' }); });
  prev.addEventListener('click', function() { track.scrollBy({ left: -getScrollUnit(), behavior: 'smooth' }); });
  track.addEventListener('scroll', updateDividers, { passive: true });
  updateDividers();
})();

/* === outlet carousel === */
(function() {
  var track = document.getElementById('ab-oc-track');
  var prev  = document.getElementById('ab-oc-prev');
  var next  = document.getElementById('ab-oc-next');
  var dotsWrap = document.getElementById('ab-oc-dots');
  if (!track || !prev || !next || !dotsWrap) return;
  var cards = [].slice.call(track.querySelectorAll('.ab-oc-card'));
  if (!cards.length) return;

  function getScrollUnit() {
    if (cards.length < 2) return cards[0].offsetWidth;
    return cards[1].offsetLeft - cards[0].offsetLeft;
  }
  function activeIndex() {
    return Math.round(track.scrollLeft / getScrollUnit());
  }

  // Build dots (one per card)
  var dots = cards.map(function(_, i) {
    var d = document.createElement('button');
    d.className = 'ab-oc-dot' + (i === 0 ? ' is-active' : '');
    d.setAttribute('aria-label', 'Go to slide ' + (i + 1));
    d.addEventListener('click', function() {
      track.scrollTo({ left: i * getScrollUnit(), behavior: 'smooth' });
    });
    dotsWrap.appendChild(d);
    return d;
  });

  function updateDots() {
    var a = activeIndex();
    dots.forEach(function(d, i) { d.classList.toggle('is-active', i === a); });
  }

  next.addEventListener('click', function() { track.scrollBy({ left: getScrollUnit(), behavior: 'smooth' }); });
  prev.addEventListener('click', function() { track.scrollBy({ left: -getScrollUnit(), behavior: 'smooth' }); });
  track.addEventListener('scroll', updateDots, { passive: true });
  updateDots();
})();

/* === main controller: connector switcher / nav dots / sticky bar / FAQ === */
(function() {
  'use strict';

  /* ── Connector data ─────────────────────────────────────── */
  var CONN = {
    nacs: {
      heroImgSrc: ((window.WS_LANDING_CONN && window.WS_LANDING_CONN.nacs && window.WS_LANDING_CONN.nacs.heroImgSrc) || ''),
      h1Html: '<span>One Kit.</span><span>Tesla Guests Covered.</span><span class="muted">NACS Host Setup.</span>',
      heroDesc: 'The WenStorm NACS 32A Host Kit charges Tesla guests natively, and handles all other EVs with the included J1772 adapter. Plug in — done.',
      heroCta: 'Build NACS Host Kit &rarr;',
      heroBtnOutline: 'See All Kits',
      barConnText: '&middot; Tesla-first NACS setup',
      barHref: '/products/universal-host-kit-nacs-32a',
      chips: ['Works on 240V', 'Tesla-First', 'NACS + J1772 Adapter', 'Portable']
    },
    j1772: {
      heroImgSrc: ((window.WS_LANDING_CONN && window.WS_LANDING_CONN.j1772 && window.WS_LANDING_CONN.j1772.heroImgSrc) || ''),
      h1Html: '<span>Serve Tesla</span><span class="muted">and Non-Tesla</span><span>Guests.</span>',
      heroDesc: 'One flexible charging setup for every guest. More 5-star reviews. More bookings.',
      heroCta: 'BUILD HOST CHARGING KIT ↘',
      heroBtnOutline: 'See How It Works',
      barConnText: '&middot; Serves Tesla + all EVs',
      barHref: '/products/universal-host-kit-32a',
      chips: ['Works on 120V or 240V', 'Tesla + Non-Tesla', 'No Wall Charger Needed', 'Portable']
    }
  };

  /* ── DOM refs ───────────────────────────────────────────── */
  var heroImg      = document.getElementById('ab-hero-img');
  var heroH1       = document.getElementById('ab-hero-h1');
  var heroDesc     = document.getElementById('ab-hero-desc');
  var heroChips    = document.getElementById('ab-hero-chips');
  var heroCta      = document.getElementById('ab-hero-cta');
  var navCta       = document.getElementById('ab-nav-cta');
  var barConn      = document.getElementById('ab-bar-conn');
  var barCta       = document.getElementById('ab-bar-cta');
  var kitBundleCta = document.getElementById('ab-kit-bundle-cta');
  var stickyBar    = document.getElementById('ab-sticky-bar');
  var connBtns     = document.querySelectorAll('.ab-connector-btn');
  var barBtns      = document.querySelectorAll('.ab-sticky-bar-btn');

  /* ── switchConnector(key) ───────────────────────────────── */
  function switchConnector(key) {
    var d = CONN[key];
    if (!d) return;

    /* Connector ring buttons */
    connBtns.forEach(function(b) { b.classList.remove('active'); });
    var activeBtn = document.querySelector('[data-conn="' + key + '"]');
    if (activeBtn) activeBtn.classList.add('active');

    /* Sticky bar toggle buttons */
    barBtns.forEach(function(b) { b.classList.remove('on'); });
    var activeBar = document.querySelector('[data-bar-conn="' + key + '"]');
    if (activeBar) activeBar.classList.add('on');

    /* Hero image — fade transition */
    if (heroImg) {
      heroImg.style.transition = 'opacity .35s';
      heroImg.style.opacity = '0';
      setTimeout(function() {
        heroImg.src = d.heroImgSrc;
        heroImg.style.opacity = '1';
        setTimeout(function() { heroImg.style.transition = ''; heroImg.style.opacity = ''; }, 400);
      }, 320);
    }

    /* Hero H1 */
    if (heroH1) heroH1.innerHTML = d.h1Html;

    /* Hero subtitle */
    if (heroDesc) heroDesc.textContent = d.heroDesc;

    /* Hero chips */
    if (heroChips) {
      var chipsHTML = '';
      var classes = ['ab-chip ab-chip-blue', 'ab-chip', 'ab-chip', 'ab-chip'];
      d.chips.forEach(function(chip, i) {
        chipsHTML += '<div class="' + (classes[i] || 'ab-chip') + '">' + chip + '</div>';
      });
      heroChips.innerHTML = chipsHTML;
    }

    /* Hero primary CTA */
    if (heroCta) {
      heroCta.textContent = d.heroCta;
      heroCta.href = '#ab-kit-builder';
    }

    /* Nav CTA */
    if (navCta) { navCta.textContent = 'Build Host Kit \u2192'; navCta.href = '#ab-kit-builder'; }

    /* Sticky bar connector label */
    if (barConn) barConn.innerHTML = d.barConnText;

    /* Sticky bar CTA href */
    if (barCta) barCta.href = d.barHref;

    /* Kit builder featured CTA */
    if (kitBundleCta && key === 'nacs') {
      kitBundleCta.href = '/products/universal-host-kit-nacs-32a';
    } else if (kitBundleCta) {
      kitBundleCta.href = '/products/universal-host-kit-32a-ext';
    }
  }

  /* ── Connector circle click listeners ──────────────────── */
  connBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      switchConnector(btn.getAttribute('data-conn'));
    });
  });

  /* ── Bar toggle click listeners ─────────────────────────── */
  barBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      switchConnector(btn.getAttribute('data-bar-conn'));
    });
  });

  /* ── Sticky bar: show when Zone B enters viewport ───────── */
  var directAnswer = document.getElementById('ab-direct-answer');

  if (stickyBar && directAnswer) {
    var barIO = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          stickyBar.classList.add('visible');
        } else if (e.boundingClientRect.top > 0) {
          stickyBar.classList.remove('visible');
        }
      });
    }, { threshold: 0 });
    barIO.observe(directAnswer);
  }

  /* ── Nav dots: 2 dots — Hero (ab-s0) + Guide (ab-kit-builder) ── */
  var trackSections = [
    document.getElementById('ab-s0'),
    document.getElementById('ab-kit-builder')
  ];
  var dots = document.querySelectorAll('.ab-dot');

  var dotIO = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) {
        var idx = trackSections.indexOf(e.target);
        if (idx >= 0) {
          dots.forEach(function(d) { d.classList.remove('active'); });
          if (dots[idx]) dots[idx].classList.add('active');
        }
      }
    });
  }, { threshold: 0.35 });

  trackSections.forEach(function(s) { if (s) dotIO.observe(s); });

  dots.forEach(function(d) {
    d.addEventListener('click', function() {
      var idx = parseInt(d.getAttribute('data-section'), 10);
      var target = trackSections[idx];
      if (target) target.scrollIntoView({ behavior: 'smooth' });
    });
  });

  /* ── FAQ accordion ──────────────────────────────────────── */
  document.querySelectorAll('.ab-faq-q').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = btn.closest('.ab-faq-item');
      var isOpen = item.classList.contains('open');
      /* Close all */
      document.querySelectorAll('.ab-faq-item').forEach(function(i) { i.classList.remove('open'); });
      /* Re-open if it wasn't open */
      if (!isOpen) item.classList.add('open');
    });
  });

})();

/* === HERO CONNECTOR SWITCH — generic NACS/J1772 profile toggle ===
   Reads window.WS_LANDING_CONN (emitted per-page by landing-hero from settings).
   Swaps hero description, primary CTA text+link, and (optionally) hero image.
   No-ops on pages without the switch or without profile data. */
(function() {
  'use strict';
  var CONN = window.WS_LANDING_CONN;
  var sw   = document.getElementById('ab-conn-switch');
  if (!CONN || !sw) return;

  var heroDesc = document.getElementById('ab-hero-desc');
  var heroCta  = document.getElementById('ab-hero-cta');
  var heroImg  = document.getElementById('ab-hero-img');
  var thumb    = sw.querySelector('.ab-conn-thumb');

  var current = null;

  /* size + slide the blue thumb to the active option (which is wider — it shows its label) */
  function positionThumb() {
    var a = sw.querySelector('.ab-conn-opt[data-conn="' + current + '"]');
    if (a && thumb) {
      thumb.style.left  = a.offsetLeft + 'px';
      thumb.style.width = a.offsetWidth + 'px';
    }
  }

  function apply(key, instant) {
    var d = CONN[key];
    if (!d || key === current) return;
    current = key;
    /* drive the sliding pill + active-label color (CSS handles the motion) */
    sw.classList.toggle('is-nacs',  key === 'nacs');
    sw.classList.toggle('is-j1772', key === 'j1772');

    /* reposition thumb to the (now relabelled) active option */
    if (instant && thumb) {
      thumb.style.transition = 'none';
      positionThumb();
      /* force reflow, then restore the slide transition for later clicks */
      void thumb.offsetWidth;
      thumb.style.transition = '';
    } else {
      positionThumb();
    }

    function setText() {
      if (heroDesc && d.desc)    heroDesc.textContent = d.desc;
      /* heroCta text/href are owned by landing-hero.liquid's own inline script
         (real per-bundle href + add-to-cart behavior) — don't overwrite them here. */
    }
    if (instant) {
      setText();
    } else {
      /* fade text/CTA out, swap, fade back in (CSS transitions the opacity) */
      if (heroDesc) heroDesc.style.opacity = '0';
      if (heroCta)  heroCta.style.opacity  = '0';
      setTimeout(function() {
        setText();
        if (heroDesc) heroDesc.style.opacity = '1';
        if (heroCta)  heroCta.style.opacity  = '1';
      }, 160);
    }
    if (heroImg && d.img) {
      heroImg.style.transition = 'opacity .3s';
      heroImg.style.opacity = '0';
      setTimeout(function() { heroImg.src = d.img; heroImg.style.opacity = '1'; }, 280);
    }
  }

  [].forEach.call(sw.querySelectorAll('.ab-conn-opt'), function(b) {
    b.addEventListener('click', function() { apply(b.getAttribute('data-conn')); });
  });

  /* reposition (no animation) — layout/label-width can change after load/resize/font load */
  function snapThumb() {
    if (!thumb) return;
    thumb.style.transition = 'none';
    positionThumb();
    void thumb.offsetWidth;
    thumb.style.transition = '';
  }
  window.addEventListener('resize', snapThumb);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(snapThumb);
  setTimeout(snapThumb, 150);

  apply(CONN['default'] || 'j1772', true);
})();

/* ------------------------------------------------------------------
   Pointer-following table highlight (desktop only)

   Two landing tables ship with a blue band baked into the markup: the
   Outlet Guide highlights one ROW (.ab-outlet-highlight) and Compare
   Your Options highlights one COLUMN (.hl on that column's th + tds).
   Both were meant to track the pointer. This moves those exact classes
   — no new styling — onto whatever row/column is hovered. The band then
   STAYS where it was last left; the markup's own row/column is only the
   starting position, not something to snap back to.

   Guarded on (hover: hover) and (pointer: fine): on touch, mouseover
   fires on tap, so there the band simply stays where the markup put it.
   ------------------------------------------------------------------ */
(function () {
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

  function rows(table) {
    return table.tBodies[0] ? Array.prototype.slice.call(table.tBodies[0].rows) : [];
  }

  function initRowTable(table) {
    if (table.dataset.hlBound) return;
    table.dataset.hlBound = '1';

    var all = rows(table);
    if (all.length < 2) return;

    function setActive(row) {
      for (var i = 0; i < all.length; i++) {
        all[i].classList.toggle('ab-outlet-highlight', all[i] === row);
      }
    }

    table.addEventListener('mouseover', function (e) {
      if (!canHover.matches) return;
      var row = e.target.closest ? e.target.closest('tr') : null;
      if (row && all.indexOf(row) !== -1) setActive(row);
    });
  }

  function initColTable(table) {
    if (table.dataset.hlBound) return;
    table.dataset.hlBound = '1';

    var head = table.tHead && table.tHead.rows[0];
    if (!head) return;

    function setActive(index) {
      Array.prototype.forEach.call(table.rows, function (row) {
        Array.prototype.forEach.call(row.cells, function (cell, i) {
          cell.classList.toggle('hl', i === index);
        });
      });
    }

    table.addEventListener('mouseover', function (e) {
      if (!canHover.matches) return;
      var cell = e.target.closest ? e.target.closest('th, td') : null;
      if (!cell || cell.closest('table') !== table) return;
      /* column 0 is the row-label column, never part of the comparison */
      if (cell.cellIndex > 0) setActive(cell.cellIndex);
    });
  }

  function init(root) {
    var scope = root || document;
    Array.prototype.forEach.call(scope.querySelectorAll('.ab-outlet-table'), initRowTable);
    Array.prototype.forEach.call(scope.querySelectorAll('.ab-compare-table'), initColTable);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* ── Build-your-kit CTA anatomy ───────────────────────────────────────
   The lusion.co button effect needs three pieces inside the pill: a dot,
   the label in its own span, and an arrow parked off the right edge.
   Built here rather than in the Liquid because the label also arrives
   from a block setting that may already end in an arrow character —
   that gets stripped so the real SVG arrow is the only one.
   ------------------------------------------------------------------ */
(function () {
  var ARROW =
    '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
    '<path d="M2.343 8h11.314m0 0L8.673 3.016M13.657 8l-4.984 4.984" ' +
    'stroke="currentColor" stroke-width="2"/></svg>';

  function build(btn) {
    if (btn.dataset.ctaBuilt) return;
    btn.dataset.ctaBuilt = '1';
    var label = (btn.textContent || '').replace(/[→↗➡>]\s*$/, '').trim();
    btn.textContent = '';
    var dot = document.createElement('span');
    dot.className = 'ab-byk-cta-dot';
    var text = document.createElement('span');
    text.className = 'ab-byk-cta-text';
    text.textContent = label;
    var arrow = document.createElement('span');
    arrow.className = 'ab-byk-cta-arrow';
    arrow.innerHTML = ARROW;
    btn.appendChild(dot);
    btn.appendChild(text);
    btn.appendChild(arrow);
  }

  function init() {
    document.querySelectorAll('.ab-byk-card-btn').forEach(build);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

/* ── Problem-card title animation ─────────────────────────────────────
   Copied from lusion.co's ProjectItem class (read out of their bundle).
   Their code, reproduced here in full so the numbers are traceable:

     TEXT_STAGGER = 20, LETTER_PER_SECOND = 40, MAX_RAND_LETTER_COUNT = 5

     // build
     u = domFooterLine2.textContent.split("")
     p.style.display = "flex"; p.style.flexDirection = "column"
     p.style.transform = "translateY(-400%)"
     if (f === " ") p.style.width = "0.3em"
     else for (let g = 0; g < 4; g++) p.appendChild(<span>f</span>)

     // per frame
     domFooterLine2HoverRatio = saturate(prev + (isHoverDom ? 1 : -1) * dt * 2.5)
     domFooterLine2Time += dt * 0.8
     list.forEach((u, f) => {
       p = fit(f, 0, len - 1, PI/2, 3*PI/2)
       g = saturate(line2Time - cos(p) / TEXT_STAGGER)
       v = fit(g, 0, 1, 500, 0, ease.expoInOut)
       _ = saturate(hoverRatio - abs(f - (len - 1)) / 100)
       T = fit(_, 0, 1, 0, 1.5, ease.lusion)
       u.style.transform = `translate3d(${T}em, -${v}%, 0)`
     })
     icon.style.transform = `translateX(${fit(hoverRatio, .3, 1, 0, 1, ease.lusion)}em)`

   So: the vertical 500%->0% drop is the ENTRANCE, cosine-staggered across
   the string so the middle characters lead; the hover is a HORIZONTAL run
   out to 1.5em, staggered 10ms per character counted back from the last
   one. Both land in one combined transform.
   ease.lusion is their cubicBezier(e, .35, 0, 0, 1).
   ------------------------------------------------------------------ */
(function () {
  var TEXT_STAGGER = 20;
  var LETTER_PER_SECOND = 40;
  var MAX_RAND_LETTER_COUNT = 5;

  function saturate(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
  function cUnMix(a, b, v) { return saturate((v - a) / (b - a)); }
  function fit(v, inA, inB, outA, outB, ease) {
    v = cUnMix(inA, inB, v);
    if (ease) v = ease(v);
    return outA + v * (outB - outA);
  }
  function expoInOut(e) {
    if (e === 0) return 0;
    if (e === 1) return 1;
    if ((e *= 2) < 1) return 0.5 * Math.pow(1024, e - 1);
    return 0.5 * (-Math.pow(2, -10 * (e - 1)) + 2);
  }
  // their ease.lusion = cubicBezier(e, .35, 0, 0, 1), solved by bisection
  function lusion(t) {
    if (t <= 0) return 0;
    if (t >= 1) return 1;
    var x1 = 0.35, y1 = 0, x2 = 0, y2 = 1;
    var lo = 0, hi = 1, s = t, i, x;
    for (i = 0; i < 24; i++) {
      s = (lo + hi) / 2;
      var mt = 1 - s;
      x = 3 * mt * mt * s * x1 + 3 * mt * s * s * x2 + s * s * s;
      if (x < t) lo = s; else hi = s;
    }
    var m = 1 - s;
    return 3 * m * m * s * y1 + 3 * m * s * s * y2 + s * s * s;
  }

  var cards = [];

  function buildTitle(title) {
    var chars = (title.textContent || '').split('');
    title.textContent = '';
    var list = [];
    var word = null;
    chars.forEach(function (f) {
      var p = document.createElement('div');
      p.className = 'ab-prob-char';
      if (f === ' ') {
        p.style.width = '0.3em';
      } else {
        for (var g = 0; g < 4; g++) {
          var v = document.createElement('span');
          v.textContent = f;
          p.appendChild(v);
        }
      }
      p.style.transform = 'translateY(-400%)';
      list.push(p);
      // their line is one long nowrap row; ours has to wrap, so each run of
      // non-space characters gets its own inline-flex box to break between
      if (f === ' ') {
        title.appendChild(wrap(p));
        word = null;
      } else {
        if (!word) { word = document.createElement('span'); word.className = 'ab-prob-word'; title.appendChild(word); }
        word.appendChild(p);
      }
    });
    return list;
  }

  function wrap(node) {
    var w = document.createElement('span');
    w.className = 'ab-prob-word';
    w.appendChild(node);
    return w;
  }

  function scramble(el, realText, time) {
    var n = Math.min(realText.length, Math.floor(LETTER_PER_SECOND * time) - MAX_RAND_LETTER_COUNT);
    var a = Math.min(realText.length, Math.floor(LETTER_PER_SECOND * time));
    var out = '';
    var c;
    for (c = 0; c < n; c++) out += realText[c];
    for (c = 0; c < a - n; c++) out += String.fromCharCode(33 + ~~(Math.random() * 93));
    el.textContent = out;
  }

  function init() {
    var cells = document.querySelectorAll('.ab-prob-cell');
    if (!cells.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    Array.prototype.forEach.call(cells, function (cell) {
      if (cell.dataset.lusionBuilt) return;
      cell.dataset.lusionBuilt = '1';
      var title = cell.querySelector('.ab-prob-title');
      if (!title) return;
      cards.push({
        cell: cell,
        icon: cell.querySelector('.ab-prob-arrow'),
        list: buildTitle(title),
        hoverRatio: 0,
        line2Time: 0,
        line1Time: 0,
        shownAt: 0,
        isHover: false
      });
      cell.addEventListener('mouseenter', function () { setHover(cell, true); });
      cell.addEventListener('mouseleave', function () { setHover(cell, false); });
    });

    var eyebrow = document.querySelector('.ab-problem-eyebrow');
    var eyebrowText = eyebrow ? eyebrow.textContent : null;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var card = cards.filter(function (c) { return c.cell === entry.target; })[0];
          if (card && entry.isIntersecting && !card.shownAt) {
            card.shownAt = performance.now();
            io.unobserve(card.cell);
            if (init.ensureRunning) init.ensureRunning();
          }
        });
      }, { threshold: 0.25 });
      cards.forEach(function (c) { io.observe(c.cell); });
    } else {
      cards.forEach(function (c) { c.shownAt = performance.now(); });
    }

    var last = performance.now();
    var running = false;

    // Their loop runs for the life of the page because their whole site is
    // one rAF-driven scene. Ours has no reason to: once every entrance has
    // played and no card is hovered, the transforms are final, so the loop
    // stops writing and parks until something actually changes.
    function needsWork() {
      if (eyebrow && eyebrowText && !eyebrow.dataset.scrambleDone) return true;
      for (var i = 0; i < cards.length; i++) {
        var c = cards[i];
        if (c.isHover || c.hoverRatio > 0) return true;
        if (c.shownAt && c.line2Time < 1.15) return true;
      }
      return false;
    }
    function ensureRunning() {
      if (running) return;
      running = true;
      last = performance.now();
      requestAnimationFrame(frame);
    }
    init.ensureRunning = ensureRunning;

    function frame(now) {
      var dt = Math.min((now - last) / 1000, 0.05);
      last = now;

      if (eyebrow && eyebrowText && !eyebrow.dataset.scrambleDone && cards.length && cards[0].shownAt) {
        var l1 = (now - cards[0].shownAt) / 1000;
        if (Math.floor(LETTER_PER_SECOND * l1) - MAX_RAND_LETTER_COUNT >= eyebrowText.length) {
          // reveal is over — restore the real string exactly and never touch it again
          eyebrow.textContent = eyebrowText;
          eyebrow.dataset.scrambleDone = '1';
        } else {
          scramble(eyebrow, eyebrowText, l1);
        }
      }

      cards.forEach(function (card) {
        card.hoverRatio = saturate(card.hoverRatio + (card.isHover ? 1 : -1) * dt * 2.5);
        // wall-clock, not accumulated dt: a throttled tab (background, or a
        // slow frame) must never be able to strand the title mid-entrance
        // with the text still parked off-screen.
        if (card.shownAt) card.line2Time = ((now - card.shownAt) / 1000) * 0.8;
        var len = card.list.length;
        card.list.forEach(function (u, f) {
          var p = fit(f, 0, len - 1, Math.PI / 2, 3 * Math.PI / 2);
          var g = saturate(card.line2Time - Math.cos(p) / TEXT_STAGGER);
          var v = fit(g, 0, 1, 500, 0, expoInOut);
          var h = saturate(card.hoverRatio - Math.abs(f - (len - 1)) / 100);
          var T = fit(h, 0, 1, 0, 1.5, lusion);
          u.style.transform = 'translate3d(' + T.toFixed(3) + 'em, -' + v.toFixed(2) + '%, 0)';
        });
        if (card.icon) {
          var c = fit(card.hoverRatio, 0.3, 1, 0, 1, lusion);
          card.icon.style.transform = 'translateX(' + c.toFixed(3) + 'em)';
        }
      });
      if (needsWork()) {
        requestAnimationFrame(frame);
      } else {
        running = false;
      }
    }
    ensureRunning();
  }

  function setHover(cell, on) {
    cards.forEach(function (c) { if (c.cell === cell) c.isHover = on; });
    if (init.ensureRunning) init.ensureRunning();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
